
export function snrColor(snr: number): string {
  if (snr <= -15) {
    return 'red';
  } else if (snr <= -7) {
    return 'amber';
  } else {
    return 'green';
  }
}

export function rssiColor(rssi: number): string {
  if (rssi <= -126) {
    return 'red';
  } else if (rssi <= -115) {
    return 'amber';
  } else {
    return 'green';
  }
}


export function spreadingFactorColor(spreadingFactor: number): string {
  const colors: Record<number, string> = {
    7: '#c9e52f',
    8: '#a6d75b',
    0: '#76c68f',
    10: '#48b5c4',
    11: '#22a7f0',
    12: '#1984c5',
  };

  return colors[spreadingFactor];
}
